import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import keyAttributesText from './configs/keyAttributes'

import Panel from './Panel'

const Container = styled.div`
  margin-top: 20px;
  text-align: left;
`
const ListContainer = styled.div`
  padding: 10px;
`
const List = styled.ol`
  margin-left: 15px;
`
const Big = styled.div`
  font-size: 15px;
`
const Spacer = styled.div`
  height: 1.25em;
  line-height: 1.25em;
`
const Item = styled.li`
  font-size: 14px;
`

const KeyAttributes = ({ keyAttributes = [], needsRedecision }) => {
  if (!needsRedecision && keyAttributes.length > 0) {
    return (
      <Container>
        <Panel title="Key Attributes">
          <ListContainer>
            <Big>Below are the key attributes that contributed to the R-factor:</Big>
            <Spacer />
            <List>
              {keyAttributes.map(attribute => <Item key={attribute}>{keyAttributesText[attribute]}</Item>)}
            </List>
          </ListContainer>
        </Panel>
      </Container>
    )
  } else {
    return null
  }
}

KeyAttributes.propTypes = {
  keyAttributes: PropTypes.arrayOf(PropTypes.string),
  needsRedecision: PropTypes.bool
}

export default KeyAttributes
